import React from 'react'
import { config } from 'enviroment.js'
import axios from 'axios'
import { message, Empty, Button } from 'antd'
import {
  DndContext,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable'
import 'antd/dist/antd.css'
import 'Pages/Admin/Admin.scss'
import { getCookie } from 'common/utils/auth'
import VideoItem from 'Pages/Admin/Components/VideoItem'

const headers = {
  'Content-Type': 'application/json',
  Authorization: `Bearer ${getCookie('token')}`,
}

function VideoSection(props) {
  const {
    items,
    expInfo,
    setVisible,
    setActiveItem,
    setLoading,
    setItems,
  } = props
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  )

  const openAddItemModal = () => {
    setVisible(true)
    setActiveItem({
      actionType: 'add',
      mediaType: 'video',
      xExperienceId: expInfo.xExperienceId,
    })
  }

  function handleDragEnd(event) {
    const { active, over } = event
    const oldIndex = items.findIndex((item) => item.id === active.id)
    const newIndex = items.findIndex((item) => item.id === over.id)
    const selectedItem = items[oldIndex]
    const overItem = items[newIndex]
    if (active.id !== over.id) {
      setLoading({ status: true, type: 'action' })
      setItems((items) => {
        return arrayMove(items, oldIndex, newIndex)
      })
      const needsReorder =
        items.filter((item) =>
          [selectedItem.orderNumber, overItem.orderNumber].includes(
            item.orderNumber
          )
        ).length > 2
      
      const xExperienceId = selectedItem.xExperienceId || expInfo.xExperienceId
      
      axios
        .post(
          config.raUrl +
            `/admin/experiences/${xExperienceId}/updateMediaOrder/?reorder=${needsReorder}`,
          {
            selectedItemId: selectedItem.id,
            selectedItemOrder: selectedItem.orderNumber,
            overItemOrder: overItem.orderNumber,
            mediaType: 'video',
            selectedIndex: oldIndex,
            overIndex: newIndex,
          },
          { headers }
        )
        .then((res) => {
          setItems(res.data)
          setLoading({ status: false })
          message.success('Video order updated successfully!')
        })
        .catch((err) => {
          console.log('error caught: ', err)
          message.error('Something went wrong!')
        })
    }
  }

  return (
    <div className="section-container">
      <div className="section-header">
        <div className="section-header-title">Videos</div>
        <Button
          type="primary"
          size="small"
          className="action-btn"
          onClick={openAddItemModal}
        >
          Add Video
        </Button>
      </div>
      <div className="section-items">
        {items.length > 0 ? (
          <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext items={items}>
              {items.map((el) => (
                <VideoItem
                  key={el.id}
                  id={el.id}
                  el={el}
                  setVisible={setVisible}
                  setActiveItem={setActiveItem}
                />
              ))}
            </SortableContext>
          </DndContext>
        ) : (
          <Empty description={<span>There are no videos for this experience.</span>} />
        )}
      </div>
    </div>
  )
}
export default VideoSection

